import { deleteGenre, getGenres, saveGenre, updateGenre } from '@/services/community/wikigamer/games/genres'
export default {
	namespaced: true,
	state: {
		genreList: {
			meta: {
				total: 0,
			},
		},
		genreStatus: 'pending',
	},
	getters: {
		getGenreList(state) {
			return state.genreList
		},
		getGenreStatus(state) {
			return state.genreStatus
		},
	},
	mutations: {
		SET_GENRE_LIST(state, value) {
			state.genreList = value
		},
		SET_GENRE_STATUS(state, value) {
			state.genreStatus = value
		},
	},
	actions: {
		async fetchGenres({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SET_GENRE_STATUS', 'pending')
			commit('SET_GENRE_LIST', {
				meta: {
					total: 0,
				},
			})
			try {
				const { data } = await getGenres(params)
				commit('SET_GENRE_STATUS', 'init')
				commit('SET_GENRE_LIST', data)
				return data
			} catch (error) {
				commit('SET_GENRE_STATUS', 'init')
				throw error
			}
		},

		async deleteGenreRecord({ commit }, params) {
			commit('SET_GENRE_STATUS', 'pending')
			try {
				const { data } = await deleteGenre(params)
				commit('SET_GENRE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_GENRE_STATUS', 'init')
				throw error
			}
		},
		async saveGenre({ commit }, params) {
			commit('SET_GENRE_STATUS', 'pending')
			try {
				const { data } = await saveGenre(params)
				commit('SET_GENRE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_GENRE_STATUS', 'init')
				throw error
			}
		},
		async updateGenre({ commit }, params) {
			commit('SET_GENRE_STATUS', 'pending')
			try {
				const { data } = await updateGenre(params)
				commit('SET_GENRE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_GENRE_STATUS', 'init')
				throw error
			}
		},
	},
}
